(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // Mobile nav
  const menuBtn = qs("[data-menu-toggle]");
  const mobileNav = qs("[data-mobile-nav]");
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener("click", () => {
      const open = mobileNav.hasAttribute("hidden") === false;
      mobileNav.toggleAttribute("hidden", open);
      menuBtn.setAttribute("aria-expanded", String(!open));
    });
  }

  // Cart drawer
  const drawer = qs("#CartDrawer");
  const cartBody = qs("[data-cart-body]");
  const cartCount = qs("[data-cart-count]");

  function openCart() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
  }
  qsa("[data-cart-open]").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      refreshCart().then(openCart);
    });
  });
  qsa("[data-cart-close]").forEach((el) => el.addEventListener("click", closeCart));

  async function refreshCart() {
    try {
      const cart = await fetch("/cart.js").then((r) => r.json());
      if (cartCount) {
        cartCount.textContent = cart.item_count || "";
        cartCount.setAttribute("data-cart-count", String(cart.item_count || 0));
      }
      if (!cartBody) return cart;
      if (!cart.items.length) {
        cartBody.innerHTML = `<p>Your cart is empty.</p>`;
        return cart;
      }
      cartBody.innerHTML = cart.items.map((item) => `
        <div class="cart-line">
          <div>
            <strong>${item.product_title}</strong>
            <p>${item.variant_title || ""} × ${item.quantity}</p>
          </div>
          <div>${formatMoney(item.final_line_price)}</div>
        </div>
      `).join("") + `
        <p style="margin:16px 0"><strong>Subtotal:</strong> ${formatMoney(cart.total_price)}</p>
        <form action="/cart" method="post">
          <button class="btn btn--primary btn--block" type="submit" name="checkout" data-cart-checkout>Checkout</button>
        </form>
      `;
      return cart;
    } catch (err) {
      if (cartBody) cartBody.innerHTML = "<p>Unable to load cart.</p>";
    }
  }

  function shopPath(path) {
    const root = window.Shopify?.routes?.root || "/";
    return `${root}${String(path || "").replace(/^\//, "")}`;
  }
  function postForm(action, fields) {
    const form = document.createElement("form");
    form.method = "post";
    form.action = action;
    form.acceptCharset = "UTF-8";
    Object.entries(fields || {}).forEach(([name, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = String(value);
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }
  function checkoutCart() {
    postForm(shopPath("cart"), { checkout: "" });
  }
  async function addToCart(id, quantity) {
    const body = new FormData();
    body.set("id", String(id));
    body.set("quantity", String(quantity || 1));
    const res = await fetch(shopPath("cart/add.js"), { method: "POST", body });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || "Could not add this product to cart.");
    }
    return res.json();
  }
  function checkoutWithItem(id, quantity) {
    postForm(shopPath("cart/add"), {
      id,
      quantity: quantity || 1,
      return_to: "/checkout"
    });
  }
  cartBody?.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-cart-checkout]");
    if (!trigger) return;
    event.preventDefault();
    checkoutCart();
  });

  function formatMoney(cents, format) {
    const value = (Number(cents || 0) / 100).toFixed(2);
    const whole = String(Math.round(Number(cents || 0) / 100));
    const template = format || "${{amount}}";
    return template
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole);
  }

  // Product box — live Shopify variants, prices, Add to Cart, Buy Now
  const box = qs("[data-product-box]");
  if (box) {
    const catalogEl = qs("[data-catalog-json]", box);
    let catalog = {};
    try { catalog = catalogEl ? JSON.parse(catalogEl.textContent) : {}; } catch (e) { catalog = {}; }
    const form = qs("[data-product-form]", box);
    const variantInput = qs("[data-variant-id]", box);
    const optionsWrap = qs("[data-variant-options]", box);
    const hint = qs("[data-product-hint]", box);
    const variantLabel = qs("[data-variant-label]", box);
    const moneyFormat = box.getAttribute("data-money-format") || "${{amount}}";
    const addBtn = qs("[data-add-to-cart]", box);
    const buyBtn = qs("[data-buy-now]", box);
    const checkoutUrl = form?.getAttribute("data-checkout-url") || "/checkout";

    function selectedSetInput() {
      return qs('input[name="lg-set"]:checked', box);
    }
    function selectedProduct() {
      const input = selectedSetInput();
      if (!input) return Object.values(catalog).find(Boolean) || null;
      return catalog[input.value] || Object.values(catalog).find(Boolean) || null;
    }
    function selectedSetKey() {
      return (selectedSetInput()?.dataset.setKey || "").trim();
    }
    function optionValues(product, index) {
      const values = [];
      (product.variants || []).forEach((variant) => {
        const value = variant.options?.[index] || variant[`option${index + 1}`];
        if (value && !values.includes(value)) values.push(value);
      });
      return values;
    }
    function sizeKey(value) {
      return String(value || "").replace(/\s+/g, " ").trim().toLowerCase().replace(/^size\s+/, "");
    }
    function variantOption(variant, index) {
      return variant.options?.[index] || variant[`option${index + 1}`] || "";
    }
    function isSizeOption(name, values) {
      const label = String(name || "").toLowerCase();
      if (label.includes("size")) return true;
      return values.length > 0 && values.every((value) => /^(size\s+)?(xxs|xs|s|m|l|xl|xxl|xxxl|\d+)$/i.test(String(value).trim()));
    }
    function optionCoveredBySet(product, optionIndex) {
      const setKey = sizeKey(selectedSetKey());
      if (!setKey) return false;
      return optionValues(product, optionIndex).some((value) => sizeKey(value) === setKey);
    }
    function currentSelections(product) {
      const picks = {};
      (product.options || []).forEach((name, index) => {
        if (optionCoveredBySet(product, index)) {
          picks[index] = selectedSetKey();
          return;
        }
        const checked = qs(`input[name="lg-option-${index}"]:checked`, box);
        picks[index] = checked ? checked.value : optionValues(product, index)[0] || "";
      });
      return picks;
    }
    function findVariant(product) {
      if (!product?.variants?.length) return null;
      const picks = currentSelections(product);
      const exact = product.variants.find((variant) =>
        (product.options || []).every((_, index) => {
          const wanted = sizeKey(picks[index]);
          if (!wanted) return true;
          return sizeKey(variantOption(variant, index)) === wanted;
        })
      );
      if (exact) return exact;
      const setKey = sizeKey(selectedSetKey());
      const pool = setKey
        ? product.variants.filter((variant) => [variant.option1, variant.option2, variant.option3, variant.title].some((value) => sizeKey(value) === setKey))
        : product.variants;
      return pool.find((variant) => variant.available !== false) || pool[0] || product.variants[0];
    }
    function priceHTML(variant) {
      if (!variant) return "";
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return `<s>${formatMoney(variant.compare_at_price, moneyFormat)}</s> ${formatMoney(variant.price, moneyFormat)}`;
      }
      return formatMoney(variant.price, moneyFormat);
    }
    function isCombinationAvailable(product, index, value, picks) {
      return (product.variants || []).some((variant) => {
        if (variant.available === false) return false;
        return (product.options || []).every((_, optionIndex) => {
          if (optionIndex === index) return String(variant.options?.[optionIndex] || "") === value;
          const wanted = picks[optionIndex];
          if (!wanted) return true;
          return String(variant.options?.[optionIndex] || "") === wanted;
        });
      });
    }
    function renderOptions(product) {
      if (!optionsWrap) return;
      if (!product || product.has_only_default_variant || !(product.options || []).length) {
        optionsWrap.innerHTML = "";
        return;
      }
      const previous = {};
      qsa("[data-option-index]", optionsWrap).forEach((group) => {
        previous[group.dataset.optionIndex] = qs("input:checked", group)?.value;
      });
      const rendered = [];
      const seenSizes = [];
      (product.options || []).forEach((name, index) => {
        if (optionCoveredBySet(product, index)) return;
        let values = optionValues(product, index);
        if (!values.length) return;
        const sizeLike = isSizeOption(name, values);
        if (sizeLike) {
          values = values
            .map((value) => String(value).replace(/^size\s+/i, ""))
            .filter((value, i, list) => list.findIndex((item) => sizeKey(item) === sizeKey(value)) === i);
          if (values.every((value) => seenSizes.includes(sizeKey(value)))) return;
          values.forEach((value) => seenSizes.push(sizeKey(value)));
        } else if (values.length <= 1) {
          return;
        }
        const selected = values.find((value) => sizeKey(value) === sizeKey(previous[index])) || values[0];
        const chips = values.map((value) => `
          <label class="size-chip${sizeKey(value) === sizeKey(selected) ? " is-selected" : ""}">
            <input type="radio" name="lg-option-${index}" value="${value.replace(/"/g, "&quot;")}" ${sizeKey(value) === sizeKey(selected) ? "checked" : ""}>
            ${value}
          </label>
        `).join("");
        rendered.push(`
          <div data-option-index="${index}">
            <p class="buy-box__label">CHOOSE YOUR ${sizeLike ? "SIZE" : String(name).toUpperCase()}</p>
            <div class="size-row" role="radiogroup" aria-label="${name}">${chips}</div>
          </div>
        `);
      });
      optionsWrap.innerHTML = rendered.join("");
    }
    function refreshSetPrices() {
      const livePicks = selectedProduct() ? currentSelections(selectedProduct()) : {};
      qsa('input[name="lg-set"]', box).forEach((input) => {
        const product = catalog[input.value];
        if (!product) return;
        const setKey = (input.dataset.setKey || "").toLowerCase();
        const variant = (product.variants || []).find((item) => {
          const matchesSet = !setKey || (item.options || []).some((value) => String(value).toLowerCase() === setKey);
          const matchesOthers = (product.options || []).every((_, index) => {
            if (optionCoveredBySet(product, index) || String(item.options?.[index] || "").toLowerCase() === setKey) return true;
            const wanted = livePicks[index];
            if (!wanted) return true;
            return String(item.options?.[index] || "") === wanted;
          });
          return matchesSet && matchesOthers;
        }) || product.variants?.[0];
        const target = input.closest(".option-row")?.querySelector("[data-set-price]");
        if (target && variant) target.innerHTML = priceHTML(variant);
      });
    }
    function sync() {
      qsa(".option-row", box).forEach((row) => {
        row.classList.toggle("is-selected", row.querySelector("input")?.checked);
      });
      qsa(".size-chip", box).forEach((row) => {
        row.classList.toggle("is-selected", row.querySelector("input")?.checked);
      });
      const product = selectedProduct();
      const variant = findVariant(product);
      if (variantInput && variant) variantInput.value = variant.id;
      const media = qs("[data-product-media] img");
      if (media && variant?.featured_image) media.src = variant.featured_image;
      const ready = Boolean((variant && variant.available !== false) || variantInput?.value);
      if (addBtn) addBtn.disabled = !ready;
      if (buyBtn) buyBtn.disabled = !ready;
      if (variantLabel) {
        variantLabel.textContent = variant && variant.title && variant.title !== "Default Title" ? variant.title : "";
      }
      if (product && variant) {
        const picks = currentSelections(product);
        qsa("[data-option-index]", box).forEach((group) => {
          const index = Number(group.dataset.optionIndex);
          qsa(".size-chip", group).forEach((chip) => {
            const value = chip.querySelector("input")?.value;
            chip.classList.toggle("is-unavailable", !isCombinationAvailable(product, index, value, picks));
          });
        });
      }
      if (hint) {
        if (!product) {
          hint.hidden = false;
          hint.textContent = "Link a Shopify product in the Theme Editor to enable variants, live pricing, and checkout.";
        } else if (variant && variant.available === false) {
          hint.hidden = false;
          hint.textContent = "This variant is sold out. Choose another option.";
        } else {
          hint.hidden = true;
          hint.textContent = "";
        }
      }
      refreshSetPrices();
      return variant;
    }

    async function addSelectedVariant() {
      const variant = sync();
      if (!variantInput?.value) {
        alert("Link your Shopify product in Theme Editor → Product feature, then choose a variant.");
        return null;
      }
      await addToCart(variant.id, 1);
      return variant;
    }

    renderOptions(selectedProduct());
    sync();

    box.addEventListener("change", (event) => {
      if (event.target?.name === "lg-set") renderOptions(selectedProduct());
      sync();
    });

    if (form) {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        try {
          await addSelectedVariant();
          await refreshCart();
          openCart();
        } catch {
          form.submit();
        }
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener("click", async () => {
        const variant = sync();
        const id = variant?.id || variantInput?.value;
        if (!id) {
          if (hint) {
            hint.hidden = false;
            hint.textContent = "Choose a spec and size first.";
          }
          return;
        }
        try {
          await addToCart(id, 1);
          window.location.assign(shopPath("checkout"));
        } catch (error) {
          checkoutWithItem(id, 1);
        }
      });
    }
  }

  // Testimonials carousel (mobile-first paging, desktop remains 3-up via CSS)
  qsa("[data-carousel]").forEach((carousel) => {
    const track = qs("[data-carousel-track]", carousel);
    const prev = qs("[data-carousel-prev]", carousel.closest(".testimonials") || carousel.parentElement);
    const next = qs("[data-carousel-next]", carousel.closest(".testimonials") || carousel.parentElement);
    const dotsWrap = qs("[data-carousel-dots]", carousel.closest(".testimonials") || document);
    if (!track) return;
    const cards = qsa(":scope > *", track);
    cards.forEach((_, i) => {
      if (!dotsWrap) return;
      const dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
      if (i === 0) dot.classList.add("is-active");
      dot.addEventListener("click", () => {
        cards[i].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      });
      dotsWrap.appendChild(dot);
    });
    const scrollByCard = (dir) => {
      const card = cards[0];
      if (!card) return;
      track.scrollBy({ left: dir * (card.getBoundingClientRect().width + 18), behavior: "smooth" });
    };
    prev?.addEventListener("click", () => scrollByCard(-1));
    next?.addEventListener("click", () => scrollByCard(1));
    if (window.matchMedia("(max-width: 980px)").matches) {
      track.style.display = "flex";
      track.style.overflowX = "auto";
      track.style.scrollSnapType = "x mandatory";
      cards.forEach((c) => {
        c.style.minWidth = "min(100%, 340px)";
        c.style.scrollSnapAlign = "center";
      });
    }
  });

  // Product page — exact Shopify variant matching
  const pdp = qs("[data-product-page]");
  if (pdp) {
    let productData = { options: [], variants: [], images: [] };
    try { productData = JSON.parse(qs("[data-product-json]", pdp).textContent); } catch (e) {}
    const form = qs("[data-product-form]", pdp);
    const variantInput = qs("[data-variant-id]", pdp);
    const qtyInput = qs("[data-qty-input]", pdp);
    const hint = qs("[data-product-hint]", pdp);
    const variantLabel = qs("[data-variant-label]", pdp);
    const mainImage = qs("[data-main-image]", pdp);
    const lightbox = qs("[data-lightbox]", pdp);
    const lightboxImage = qs("[data-lightbox-image]", pdp);
    const optionsWrap = qs("[data-variant-options]", pdp);
    const moneyFormat = pdp.getAttribute("data-money-format") || "${{amount}}";

    function normalize(value) {
      return String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
    }
    function sizeKey(value) {
      return normalize(value).replace(/^size\s+/, "");
    }
    function variantOption(variant, index) {
      return variant.options?.[index] || variant[`option${index + 1}`] || "";
    }
    function optionValues(index) {
      const values = [];
      (productData.variants || []).forEach((variant) => {
        const value = variantOption(variant, index);
        if (value && !values.some((item) => normalize(item) === normalize(value))) values.push(value);
      });
      return values;
    }
    function isSizeOption(name, values) {
      const label = normalize(name);
      if (label.includes("size")) return true;
      return values.every((value) => /^(size\s+)?(xxs|xs|s|m|l|xl|xxl|xxxl|\d+)$/i.test(String(value).trim()));
    }
    function isSpecOption(name, values) {
      const blob = values.map(normalize).join(" ");
      return blob.includes("right") || blob.includes("left") || blob.includes("full") || blob.includes("set") || blob.includes("hand");
    }
    const classified = (productData.options || []).map((name, index) => {
      const values = optionValues(index);
      return {
        name,
        index,
        values,
        size: isSizeOption(name, values),
        spec: isSpecOption(name, values)
      };
    });
    const specOption = classified.find((item) => item.spec && !item.size) || classified.find((item) => item.spec) || classified.find((item) => !item.size);
    const sizeOptions = classified.filter((item) => item.size || (specOption && item.index !== specOption.index && item.values.length > 1));
    const primarySize = sizeOptions[0];

    function currentSpec() {
      if (!specOption) return "";
      return qs(`input[name="lg-option-${specOption.index}"]:checked`, pdp)?.value || specOption.values[0] || "";
    }
    function currentSize() {
      if (!primarySize) return "";
      return qs(`input[name="lg-option-${primarySize.index}"]:checked`, pdp)?.value || primarySize.values[0] || "";
    }
    function specMatches(variant, spec) {
      if (!specOption || !spec) return true;
      return normalize(variantOption(variant, specOption.index)) === normalize(spec);
    }
    function sizeMatches(variant, size) {
      if (!size) return true;
      const wanted = sizeKey(size);
      return sizeOptions.some((option) => sizeKey(variantOption(variant, option.index)) === wanted) ||
        [variant.option1, variant.option2, variant.option3, variant.title].some((value) => sizeKey(value) === wanted);
    }
    function variantsForSpec(spec) {
      return (productData.variants || []).filter((variant) => specMatches(variant, spec));
    }
    function findVariant() {
      const spec = currentSpec();
      const size = currentSize();
      const pool = variantsForSpec(spec);
      return pool.find((variant) => sizeMatches(variant, size) && variant.available !== false)
        || pool.find((variant) => sizeMatches(variant, size))
        || pool.find((variant) => variant.available !== false)
        || pool[0]
        || null;
    }
    function findPriceForSpec(value) {
      const size = currentSize();
      const pool = variantsForSpec(value);
      return pool.find((variant) => sizeMatches(variant, size)) || pool[0] || null;
    }
    function selectValue(index, value) {
      const input = qsa(`input[name="lg-option-${index}"]`, pdp).find((el) => normalize(el.value) === normalize(value) || sizeKey(el.value) === sizeKey(value));
      if (input) input.checked = true;
    }
    function rebuildOptions() {
      if (!optionsWrap || !classified.length) return;
      const specValues = specOption ? specOption.values : [];
      const sizeValues = [];
      sizeOptions.forEach((option) => {
        option.values.forEach((value) => {
          if (!sizeValues.some((item) => sizeKey(item) === sizeKey(value))) sizeValues.push(value.replace(/^size\s+/i, "").toUpperCase() === value.toUpperCase() ? value.replace(/^size\s+/i, "") : value.replace(/^size\s+/i, ""));
        });
      });
      const uniqueSizes = [];
      sizeValues.forEach((value) => {
        const clean = String(value).replace(/^size\s+/i, "");
        if (!uniqueSizes.some((item) => sizeKey(item) === sizeKey(clean))) uniqueSizes.push(clean);
      });
      const current = findVariant() || productData.variants?.[0];
      const selectedSpec = specOption ? variantOption(current || {}, specOption.index) : "";
      const selectedSize = primarySize ? sizeKey(variantOption(current || {}, primarySize.index)) : "";
      let html = "";
      if (specOption) {
        html += `<div class="variant-group" data-option-index="${specOption.index}"><p class="buy-box__label">CHOOSE YOUR SPEC</p><div class="option-list" role="radiogroup">`;
        specValues.forEach((value) => {
          const priced = findPriceForSpec(value);
          html += `<label class="option-row${normalize(value) === normalize(selectedSpec) ? " is-selected" : ""}">
            <input type="radio" name="lg-option-${specOption.index}" value="${value.replace(/"/g, "&quot;")}" ${normalize(value) === normalize(selectedSpec) ? "checked" : ""}>
            <span class="radio"></span>
            <span class="option-row__name">${value}</span>
            ${priced ? `<span class="option-row__price" data-option-price>${formatMoney(priced.price, moneyFormat)}</span>` : ""}
          </label>`;
        });
        html += `</div></div>`;
      }
      if (primarySize && uniqueSizes.length) {
        html += `<div class="variant-group" data-option-index="${primarySize.index}"><p class="buy-box__label">CHOOSE YOUR SIZE</p><div class="size-row" role="radiogroup">`;
        uniqueSizes.forEach((value) => {
          html += `<label class="size-chip${sizeKey(value) === selectedSize ? " is-selected" : ""}">
            <input type="radio" name="lg-option-${primarySize.index}" value="${value.replace(/"/g, "&quot;")}" ${sizeKey(value) === selectedSize ? "checked" : ""}>
            ${value}
          </label>`;
        });
        html += `</div></div>`;
      }
      optionsWrap.innerHTML = html;
    }
    function paintPrice(variant) {
      if (!variant) return;
      qsa("[data-current-price]").forEach((el) => { el.textContent = formatMoney(variant.price, moneyFormat); });
      qsa("[data-compare-price]").forEach((el) => {
        if (variant.compare_at_price > variant.price) {
          el.hidden = false;
          el.textContent = formatMoney(variant.compare_at_price, moneyFormat);
        } else {
          el.hidden = true;
        }
      });
      qsa("[data-save-badge]").forEach((el) => {
        if (variant.compare_at_price > variant.price) {
          el.hidden = false;
          el.textContent = `Save ${formatMoney(variant.compare_at_price - variant.price, moneyFormat)}`;
        } else {
          el.hidden = true;
        }
      });
    }
    function setMainImage(src) {
      if (!src || !mainImage) return;
      mainImage.src = src;
      if (lightboxImage) lightboxImage.src = src;
      qsa("[data-thumb]", pdp).forEach((thumb) => {
        thumb.classList.toggle("is-active", thumb.dataset.src === src);
      });
    }
    function paintOptionPrices() {
      if (!specOption) return;
      qsa(`input[name="lg-option-${specOption.index}"]`, pdp).forEach((input) => {
        const variant = findPriceForSpec(input.value);
        const priceEl = input.closest("label")?.querySelector("[data-option-price]");
        if (priceEl && variant) priceEl.textContent = formatMoney(variant.price, moneyFormat);
        input.closest("label")?.classList.toggle("is-unavailable", Boolean(variant && variant.available === false));
      });
      if (!primarySize) return;
      const spec = currentSpec();
      qsa(`input[name="lg-option-${primarySize.index}"]`, pdp).forEach((input) => {
        const exists = variantsForSpec(spec).some((variant) => sizeMatches(variant, input.value));
        input.closest("label")?.classList.toggle("is-unavailable", !exists);
      });
    }
    function sync(updateUrl) {
      let variant = findVariant();
      if (variant && specOption) selectValue(specOption.index, variantOption(variant, specOption.index));
      if (variant && primarySize) {
        const raw = variantOption(variant, primarySize.index);
        selectValue(primarySize.index, raw.replace(/^size\s+/i, "") || raw);
      }
      qsa(".option-row, .size-chip", pdp).forEach((row) => {
        row.classList.toggle("is-selected", row.querySelector("input")?.checked);
      });
      if (variant && variantInput) variantInput.value = variant.id;
      if (variant) {
        paintPrice(variant);
        if (variantLabel) variantLabel.textContent = variant.title && variant.title !== "Default Title" ? variant.title : "";
        if (variant.featured_image) setMainImage(variant.featured_image);
        if (updateUrl !== false) {
          const url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url.toString());
        }
      }
      paintOptionPrices();
      const ready = Boolean(variant && variant.available !== false);
      qsa("[data-add-to-cart], [data-buy-now], [data-sticky-add], [data-sticky-buy]").forEach((btn) => { btn.disabled = !ready; });
      if (hint) {
        if (!variant) {
          hint.hidden = false;
          hint.textContent = "This combination is not available. Choose another option.";
        } else if (variant.available === false) {
          hint.hidden = false;
          hint.textContent = "This variant is sold out. Choose another option.";
        } else {
          hint.hidden = true;
          hint.textContent = "";
        }
      }
      return variant;
    }
    function quantity() {
      const value = parseInt(qtyInput?.value || "1", 10);
      return Number.isFinite(value) && value > 0 ? value : 1;
    }
    async function addVariant() {
      const variant = sync();
      if (!variant) throw new Error("Choose a spec and size first.");
      await addToCart(variant.id, quantity());
      return variant;
    }

    try { rebuildOptions(); } catch (error) { console.warn("LyfeGrip options", error); }
    pdp.addEventListener("change", () => sync(true));
    qs("[data-qty-minus]", pdp)?.addEventListener("click", () => {
      if (!qtyInput) return;
      qtyInput.value = String(Math.max(1, quantity() - 1));
    });
    qs("[data-qty-plus]", pdp)?.addEventListener("click", () => {
      if (!qtyInput) return;
      qtyInput.value = String(quantity() + 1);
    });

    form?.addEventListener("submit", async (e) => {
      e.preventDefault();
      try {
        await addVariant();
        await refreshCart();
        openCart();
      } catch (error) {
        if (hint) {
          hint.hidden = false;
          hint.textContent = error.message || "Could not add this product. Check the selected options.";
        }
      }
    });
    function startCheckout() {
      const variant = sync();
      if (!variant) {
        if (hint) {
          hint.hidden = false;
          hint.textContent = "Choose a spec and size first.";
        }
        return;
      }
      addToCart(variant.id, quantity())
        .then(() => window.location.assign(shopPath("checkout")))
        .catch(() => checkoutWithItem(variant.id, quantity()));
    }
    qs("[data-buy-now]", pdp)?.addEventListener("click", startCheckout);
    qs("[data-sticky-add]")?.addEventListener("click", () => form?.requestSubmit());
    qs("[data-sticky-buy]")?.addEventListener("click", startCheckout);

    qsa("[data-thumb]", pdp).forEach((thumb) => {
      thumb.addEventListener("click", () => setMainImage(thumb.dataset.src));
    });
    qs("[data-zoom-open]", pdp)?.addEventListener("click", () => {
      if (!lightbox || !mainImage) return;
      if (lightboxImage) lightboxImage.src = mainImage.src;
      lightbox.hidden = false;
    });
    qs("[data-zoom-close]", pdp)?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (lightbox) lightbox.hidden = true;
    });
    lightbox?.addEventListener("click", (event) => {
      if (event.target === lightbox) lightbox.hidden = true;
    });

    sync(false);
  }

  refreshCart();
})();
